import React from 'react';
import { MusicIcon, PaletteIcon, UtensilsIcon, TrophyIcon, TreePineIcon, CalendarIcon, InstagramIcon, FacebookIcon, GlobeIcon } from 'lucide-react';
// Thumbnail size is 60x60px with 8px border radius
export function EventThumbnail({
  event
}) {
  // Determine which image to display based on priority
  const renderThumbnail = () => {
    // 1. User uploaded image has highest priority
    if (event.image) {
      return <div className="relative w-full h-full" data-id="element-276">
          <img src={event.image} alt={event.name} className="w-full h-full object-cover rounded-lg" data-id="element-277" />
        </div>;
    }
    // 2. Source type logos (Instagram, Facebook, website)
    if (event.sourceType) {
      return renderSourceLogo(event.sourceType);
    }
    // 3. Category-based icon with gradient background
    if (event.category) {
      return renderCategoryIcon(event.category, event.sourceType);
    }
    // 4. Generic placeholder as final fallback
    return <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded-lg" data-id="element-278">
        <CalendarIcon className="w-6 h-6 text-gray-400" data-id="element-279" />
      </div>;
  };
  // Render logo based on source type
  const renderSourceLogo = sourceType => {
    switch (sourceType) {
      case 'instagram':
        return <div className="w-full h-full flex items-center justify-center rounded-lg bg-gradient-to-tr from-purple-600 via-pink-500 to-orange-400" data-id="element-280">
            <InstagramIcon className="w-7 h-7 text-white" data-id="element-281" />
          </div>;
      case 'facebook':
        return <div className="w-full h-full flex items-center justify-center rounded-lg bg-blue-600" data-id="element-282">
            <FacebookIcon className="w-7 h-7 text-white" data-id="element-283" />
          </div>;
      case 'website':
        return <div className="w-full h-full flex items-center justify-center rounded-lg bg-gray-100" data-id="element-284">
            <GlobeIcon className="w-7 h-7 text-gray-600" data-id="element-285" />
          </div>;
      default:
        return null;
    }
  };
  // Render category icon with appropriate gradient background
  const renderCategoryIcon = (category, sourceType = null) => {
    let icon;
    let gradientClass;
    switch (category) {
      case 'music':
        icon = <MusicIcon className="w-6 h-6 text-white" data-id="element-286" />;
        gradientClass = 'bg-gradient-to-br from-purple-500 to-indigo-600';
        break;
      case 'art':
        icon = <PaletteIcon className="w-6 h-6 text-white" data-id="element-287" />;
        gradientClass = 'bg-gradient-to-br from-pink-500 to-rose-600';
        break;
      case 'food':
        icon = <UtensilsIcon className="w-6 h-6 text-white" data-id="element-288" />;
        gradientClass = 'bg-gradient-to-br from-orange-400 to-amber-600';
        break;
      case 'sports':
        icon = <TrophyIcon className="w-6 h-6 text-white" data-id="element-289" />;
        gradientClass = 'bg-gradient-to-br from-green-400 to-emerald-600';
        break;
      case 'outdoors':
        icon = <TreePineIcon className="w-6 h-6 text-white" data-id="element-290" />;
        gradientClass = 'bg-gradient-to-br from-emerald-400 to-teal-600';
        break;
      case 'entertainment':
        icon = <div className="w-6 h-6 text-white" data-id="element-291" />;
        gradientClass = 'bg-gradient-to-br from-violet-400 to-purple-600';
        break;
      default:
        icon = <CalendarIcon className="w-6 h-6 text-white" data-id="element-292" />;
        gradientClass = 'bg-gradient-to-br from-blue-400 to-blue-600';
        break;
    }
    // Render the category icon with optional source badge
    return <div className={`relative w-full h-full flex items-center justify-center rounded-lg ${gradientClass}`} data-id="element-293">
        {icon}
        {sourceType && renderSourceBadge(sourceType)}
      </div>;
  };
  // Render small source badge in bottom right corner
  const renderSourceBadge = sourceType => {
    let badgeIcon;
    let badgeClass;
    switch (sourceType) {
      case 'instagram':
        badgeIcon = <InstagramIcon className="w-full h-full" data-id="element-294" />;
        badgeClass = 'bg-gradient-to-tr from-purple-600 via-pink-500 to-orange-400';
        break;
      case 'facebook':
        badgeIcon = <FacebookIcon className="w-full h-full" data-id="element-295" />;
        badgeClass = 'bg-blue-600';
        break;
      case 'website':
        badgeIcon = <GlobeIcon className="w-full h-full" data-id="element-296" />;
        badgeClass = 'bg-gray-100 text-gray-600';
        break;
      default:
        return null;
    }
    return <div className={`absolute bottom-0 right-0 w-4 h-4 rounded-full ${badgeClass} flex items-center justify-center text-white shadow-sm border border-white`} data-id="element-297">
        {badgeIcon}
      </div>;
  };
  return <div className="w-[60px] h-[60px] flex-shrink-0 rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-298">
      {renderThumbnail()}
    </div>;
}